module.exports = __webpack_public_path__ + "img/soccer-ball.04d078be.svg";